import { useCallback } from 'react';
import { Segment } from '../../../services/analytics-services/segment';

import {
  MANAGE_AUTOFUND_CONFIG_CLICK,
  MANAGE_AUTOFUND_CONFIG_SAVE,
  FUND_WALLET_CLICK,
  CONFIRM_FUND_WALLET_CLICK,
} from '../../../constants/analytics-events';

export const PageEvents = {
  MANAGE_AUTOFUND_CONFIG_CLICK,
  MANAGE_AUTOFUND_CONFIG_SAVE,
  FUND_WALLET_CLICK,
  CONFIRM_FUND_WALLET_CLICK,
};

export const useTrackEvent = (eventName, source = '') => {
  return useCallback(
    (metadata) => {
      const payload = {
        ...metadata,
      };

      if (source) {
        payload.source = source;
      }

      Segment.trackEvent(eventName, payload);
    },
    [eventName, source],
  );
};
